import styled from 'styled-components';
import TaskStatus from './component';

export default styled(TaskStatus)`
  .circle {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    background-color: #f2f5f8;
    border: 1px solid var(--grey300);

    svg {
      max-width: 100%;
      max-height: 100%;

      path {
        fill: var(--grey500);
      }
    }

    &--status-pending {
      background-color: var(--primary100);
    }

    &--status-keep-an-eye {
      background-color: white;
      svg path {
        fill: var(--primary100);
      }
    }

    &--status-loading {
      background-color: white;
      svg path {
        fill: var(--primary900);
      }
    }
  }
`;
